import { useQuery } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import { fetchAllAnalytics, type AnalyticsData } from '@/services/PagesServices/AnalyticsService';

export function useAnalyticsData() {
  return useQuery({
    queryKey: ['analytics-data'],
    queryFn: async () => {
      const result = await fetchAllAnalytics();
      if (!result.success || !result.data) {
        throw new Error(result.error?.message ?? 'Failed to load analytics data');
      }
      return result.data;
    },
    staleTime: 2 * 60 * 1000,
  });
}
